class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.cookieName =
      window.customerData && window.customerData.id
        ? 'userRecentlyViewed'
        : 'recentlyViewed';
    const swiperParams = this.dataset ? this.dataset : {};
    const recent = this.getRecentlyViewedStorage(this.cookieName) || [];
    if (recent.length === 0) {
      this.style.display = 'none';
      return;
    }
    const wrapper = this.querySelector('#recently-viewed-wrapper');
    const CurrencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    recent.forEach((product) => {
      let saleBadge = ``;
      let comparePrice = Number(product.compare_price) / 100.0;
      let productPrice = Number(product.price) / 100.0;
      let compareText = ``;
      const priceDiff =
        comparePrice > 0
          ? ((comparePrice || 0) - productPrice) / comparePrice
          : 0;
      if (product.on_sale || priceDiff >= 0.1) {
        saleBadge = `<span class="bg-[#d73417] px-[2px] h-[20px] text-[12px]/[16.5px] font-medium text-white flex items-center rounded-sm mt-4">SALE</span>`;
        compareText = `<div class="slider-product-card__price text-sm/[22px] mt-1 line-through">${CurrencyFormatter.format(comparePrice).replace('.00', '')}</div>`;
      }
      let freeShipping = ``;
      if (productPrice > 99) {
        freeShipping = `<span class="text-sm/5 mt-2">Free Shipping</span>`;
      }
      let secondImage = ``;
      if (product.image2) {
        secondImage = `<img src="${product.image2}" class="slider-product-card__image object-contain h-full second-product-card-image aspect-square">`;
      }
      const slide = `<div class="swiper-slide"><houzz-product-card>
        <a class="slider-product-card flex flex-col items-start  justify-center   h-full transition hover:hover:shadow-[0_4px_8px_0px_rgba(0,0,0,.24)] py-2 px-4 houzz-product-card" href="/products/${product.handle}">
          <div class="slider-product-card__image-wrapper  h-[154px]  mx-auto mb-8 md:pt-5">
            <img src="${product.image}" class="slider-product-card__image object-contain h-full first-product-card-image aspect-square">
            ${secondImage}
          </div>
          <p class="slider-product-card__title line-clamp-3 overflow-hidden text-sm/[17.5px] text-[#222222]">${product.title}</p>
          <div class="flex justify-start items-center -ml-[2px] gap-[1px] yotpo-widget-instance"
            data-yotpo-instance-id="1194434"
            data-yotpo-product-id="${product.id}"
            data-yotpo-section-id="index"
          ></div>
          ${saleBadge}
          <div class="flex">
            <div class="slider-product-card__price text-base/[22px] mt-1 font-bold mr-1">${CurrencyFormatter.format(productPrice).replace('.00', '')}</div>
            ${compareText}
          </div>
          ${freeShipping}
        </a>
      </houzz-product-card></div>`;
      if (
        productPrice &&
        product.title !== '' &&
        product.expiry &&
        Date.now() < product.expiry
      ) {
        wrapper.insertAdjacentHTML('beforeend', slide);
      }
    });

    new Swiper('.recently-viewed-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: `#${swiperParams.id} .outside-swiper-button-next`,
        prevEl: `#${swiperParams.id} .outside-swiper-button-prev`,
      },
      pagination: {
        el: `#${swiperParams.id} .swiper-pagination`,
        clickable: true, // Let users click bullets,
        dynamicBullets: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
        },
        768: {
          slidesPerView: 3.5,
        },
        1024: {
          slidesPerView: 'auto',
        },
      },
    });
  }
  getRecentlyViewedStorage(name) {
    const item = localStorage.getItem(name);
    if (!item) return [];

    return JSON.parse(item);
  }

  getProductViewCookie(name) {
    const cookies = document.cookie.split('; ').reduce((acc, curr) => {
      const [key, val] = curr.split('=');
      acc[key] = val;
      return acc;
    }, {});

    const decodedCookie = decodeURIComponent(cookies[name]);
    return cookies[name] ? JSON.parse(decodedCookie) : [];
  }
}
if (document.getElementsByTagName('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
